import { Navigate } from 'react-router-dom';
import { AppPageKey, canAccessPage } from '@shared/lib/access';
import { useAppSelector } from '@shared/store/hooks';

interface RequirePageAccessProps {
  children: JSX.Element;
  page: AppPageKey;
}

export function RequirePageAccess({ children, page }: RequirePageAccessProps) {
  const userType = useAppSelector((state) => state.exchange.userType);

  if (!canAccessPage(userType, page)) {
    return <Navigate to="/no-access" replace />;
  }

  return children;
}
